/* eslint-disable no-console */
const debugEnabled: boolean = (() => {
    const urlParams = new URLSearchParams(window.location.search);
    const debugParam = urlParams.get('debug');

    return debugParam === 'true' || debugParam === '1';
})();

function isDebugEnabled(): boolean {
    return debugEnabled;
}

export function logMessage(
    message: any,
    ...optionalParams: any[]
): void {
    if (isDebugEnabled()) {
        console.log(message, ...optionalParams);
    }
}
